// extracted by css-extract-rspack-plugin
export default {"ResultsWrapper":"SearchPage_ResultsWrapper__3fNRq","InfosWrapper":"SearchPage_InfosWrapper__3rhjR"};